import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import { fetchWaiters, deleteWaiter, generatePin } from "../../../store/thunks/waitersThunk";
import { getWaiters, getWaiterPagination, unloadWaiters } from "../../../store/slices/datasources/waitersSliceDatasource";
import WithLoadingPage from "../commons/withLoadingPage";
import DeleteConfirmDialog from "../elements/deleteConfirmDialog";
import PageSubHeader from "../elements/pageSubHeader";
import Paginator from "../elements/paginator";
import DataTable from "./components/dataTable";

const Waiters = props => {
    
    const dispatch = useDispatch();
    const waiters = useSelector(getWaiters);
    const pagination = useSelector(getWaiterPagination);
    const { setLoading } = props;
    const [confirmDialog, setConfirmDialog] = React.useState({ showDialog: false, title: "", message: "", confirmButtonCaption: "", confirmButtonClass: "", cancelButtonCaption: "", selected: null })
    const [notify, setNotify] = React.useState(false);
    const [search, setSearch] = React.useState("");
    const [currentPage, setCurrentPage] = React.useState(1);
   
    React.useEffect(() => {
        return () => {
            dispatch(unloadWaiters());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    React.useEffect(() => {		
        async function initialize() {
            setLoading(true);
            await dispatch(fetchWaiters(getQueryFilter()));
            setLoading(false);
        }
		
        initialize();
        // eslint-disable-next-line react-hooks/exhaustive-deps
	}, [dispatch, currentPage]); 
	
    const getQueryFilter = () => {
        const queryFilter = {
            search: search,
            page: currentPage,
            paginate: 25
        };

        return {
            query: queryFilter
        };
    }

    const handleSearchInputChange = element => {
		const { value } = element.target;
		setSearch(value);
	}

    const handleSearch = async () => {
        setLoading(true);
        await dispatch(fetchWaiters(getQueryFilter()));
        setLoading(false);
    }

    const handleDelete = waiter => {
        setConfirmDialog({
            ...confirmDialog,
            showDialog: true, 
			title: "Delete Confirmation", 
			message: `Are you sure, you want to delete waiter '${waiter.nik}' ?`,
			selected: waiter
        });
    }

    const handleDeleteConfirm = async () => {
        setConfirmDialog({ ...confirmDialog, showDialog: false });
        setLoading(true);
        await dispatch(deleteWaiter({ query: {id: confirmDialog.selected.id} }))
            .then(() => setLoading(false));
    }

    const handleConfirmDialogDismiss = () => {
        setConfirmDialog({ ...confirmDialog, showDialog: false });
    }

    const handleGeneratePin = async id => {
        setLoading(true);

        if (id) {
            await dispatch(generatePin({ query: {id} })).then(() => setLoading(false));
        } else {
            await dispatch(generatePin()).then(() => setLoading(false));
        }

        setNotify(true);
    }

    const handlePageChange = page => {
        if (currentPage !== page) {
			setCurrentPage(page);
		}
    }

    return (
        <React.Fragment>
            <PageSubHeader title="Waiters" />
            <DeleteConfirmDialog
                showDialog={confirmDialog.showDialog} 
                title={confirmDialog.title} 
                message={confirmDialog.message} 
                handleConfirm={handleDeleteConfirm} 
                handleDismiss={handleConfirmDialogDismiss} 
            />
            <div className="mx-auto w-3/4">
                {notify && <div className="alert alert-info mt-5">Your Otentication PIN already sent to email.</div>}
                <div className="classic card">
                    <div className="card-header bg-light-600">
                        <div className="flex align-middle">
                            <div className="flex-grow mr-20">
                                <div className="input-group">
                                    <input id="search" name="search" type="text" className="form-control input-group-item" placeholder="Search..." value={search} onChange={handleSearchInputChange} />
                                    <button type="button" className="btn btn-primary uppercase input-group-item" onClick={handleSearch}>
                                        <i className="las la-search" />
                                    </button>
                                </div>
                            </div>
                            <div className="flex mr-5">
                                <NavLink to="/data/waiters/add" className="btn btn-primary">
                                    <i className="las la-plus" />
                                    Add New
                                </NavLink>
                            </div>
                            <div className="flex">
                                <button type="button" className="btn btn-outline-primary" onClick={() => handleGeneratePin(null)}>
                                    <i className="fas fa-fingerprint" />
                                    Generate Pin
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="card-body text-left">
                        <DataTable waiters={waiters} handleGeneratePin={handleGeneratePin} handleDelete={handleDelete} />
                        <Paginator pagination={pagination} handlePageChange={handlePageChange} />
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

export default WithLoadingPage(Waiters);